var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings_icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0001 6.65015C9.55006 6.65015 7.56006 8.64015 7.56006 11.0901C7.56006 13.5401 9.55006 15.5302 12.0001 15.5302C14.4501 15.5302 16.4401 13.5401 16.4401 11.0901C16.4401 8.64015 14.4501 6.65015 12.0001 6.65015ZM12.0001 14.0201C10.3801 14.0201 9.06006 12.7001 9.06006 11.0801C9.06006 9.46014 10.3801 8.14017 12.0001 8.14017C13.6201 8.14017 14.9401 9.46014 14.9401 11.0801C14.9401 12.7001 13.6201 14.0201 12.0001 14.0201Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.15 9.4101L19.03 2.27008C18.49 1.33008 17.21 0.600098 16.13 0.600098H7.88C6.8 0.600098 5.52 1.33008 4.98 2.27008L0.85 9.4101C0.3 10.3701 0.3 11.8101 0.85 12.7601L4.98 19.9001C5.52 20.8401 6.8 21.5701 7.88 21.5701H16.13C17.21 21.5701 18.49 20.8401 19.03 19.9001L23.16 12.7601C23.71 11.8101 23.71 10.3701 23.16 9.4101H23.15ZM21.85 12.0101L17.72 19.1501C17.44 19.6301 16.68 20.0701 16.12 20.0701H7.87C7.31 20.0701 6.55 19.6301 6.27 19.1501L2.15 12.0101C1.87 11.5301 1.87 10.6501 2.15 10.1601L6.28 3.02008C6.56 2.54008 7.32 2.1001 7.88 2.1001H16.13C16.69 2.1001 17.45 2.54008 17.73 3.02008L21.85 10.1601C22.13 10.6401 22.13 11.5201 21.85 12.0101Z",
    fill: "#ACACAC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings_icon.17d0c25414a33fa8600f694b33436426.svg";
export { ForwardRef as ReactComponent };